<div class="case-sheet-container">
  <lib-breadcrumb [list]="breadcrumbs()"></lib-breadcrumb>
  <div class="text-lg mb-5 font-semibold text-gray-800">{{pageTitle}}</div>

  <div class="p-4 space-y-6" style="overflow-y: auto;overflow-x: hidden">
    <form class="flex items-end bg-fieldset p-4 mb-3 gap-4" [formGroup]="searchForm" (ngSubmit)="searchHandler()"
      style="padding-top: 1rem; padding-bottom: 1rem; margin: 0;">
      <!-- Case/Appeal Number Input -->
      <div class="flex flex-col">
        <app-case-number-search [label]="sessionConstant.COURT_CASE_LABEL + ' Number'"
          (caseSelected)="onCaseSearchOptionSelected($event)" formControlName="caseNumber">
        </app-case-number-search>
      </div>

      <!-- Buttons -->
      <div class="flex gap-2 items-end">
        <button type="reset" mat-button color="primary" (click)="onReset()">Reset</button>
        <button type="submit" mat-flat-button color="primary">Search</button>
      </div>
    </form>
    <div *ngIf="isLoading"
      style="position: fixed; top: 0; left: 0; width: 100vw; height: 100vh; display: flex; align-items: center; justify-content: center; background: rgba(255, 255, 255, 0.7); z-index: 9999;">
      <mat-spinner></mat-spinner>
    </div>

    <div *ngIf="!isLoading && !(searchCaseList().length===0)">
      <div class="flex justify-between items-center mb-3">
        <p>Hearing Notice</p>
        <div class="flex gap-2">
          <button mat-flat-button color="warn" *ngIf="((task() !== null) && userType==='lawyer')"
            (click)="closeTaskHandler()">
            <mat-icon>close</mat-icon>
            <span>Close Task</span>
          </button>

          <button mat-button color="primary" class="print-button" [disabled]="selection.isEmpty()" (click)="onPrint()">
            <mat-icon class="print-icon" aria-hidden="true">print</mat-icon>
            <span>Print</span>
          </button>
        </div>
      </div>
      <table mat-table [dataSource]="searchCaseList()" class="mat-elevation-z8">
        <ng-container matColumnDef="select">
          <th mat-header-cell *matHeaderCellDef>
          </th>
          <td mat-cell *matCellDef="let row">
            <mat-checkbox (click)="$event.stopPropagation()" (change)="onCheckboxChange(row)"
              [checked]="selection.isSelected(row)" aria-label="Select row"></mat-checkbox>
          </td>
        </ng-container>
        <ng-container matColumnDef="appealNumber">
          <th mat-header-cell *matHeaderCellDef> {{sessionConstant.COURT_CASE_LABEL+' Number' }} </th>
          <td mat-cell *matCellDef="let element"> {{ element.appealNumber }} </td>
        </ng-container>

        <ng-container matColumnDef="oldSuitNumber">
          <th mat-header-cell *matHeaderCellDef> Old Suit Number </th>
          <td mat-cell *matCellDef="let element"> {{ element.oldAppealNumber }} </td>
        </ng-container>
        <ng-container matColumnDef="appellant">
          <th mat-header-cell *matHeaderCellDef>{{sessionConstant.FIRST_PARTY_LABEL}} </th>
          <td mat-cell *matCellDef="let element"> {{ element.appellant }} </td>
        </ng-container>
        <ng-container matColumnDef="respondant">
          <th mat-header-cell *matHeaderCellDef> {{sessionConstant.SECOND_PARTY_LABEL}}</th>
          <td mat-cell *matCellDef="let element"> {{ element.respondent }} </td>
        </ng-container>
        <ng-container matColumnDef="hearingDate">
          <th mat-header-cell *matHeaderCellDef> Hearing Date </th>
          <td mat-cell *matCellDef="let element"> {{ element.hearingDate | date: 'dd-MM-yyyy' }} </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>
  </div>
</div>